module.exports = __webpack_public_path__ + "img/shopify.04e052e7.svg";